<template>
  <div
    class="  px-10 mt-7">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-row>
            <v-col cols="8">

              <div class="mb-1 d-flex align-center">
                <div class="fs-22 color-dark-blue font-weight-medium">
                  My Cards
                </div>

                <v-spacer />

                <div class="fs-17 color-dark-blue">
                  add card
                </div>
              </div>
              <v-row>
                <v-col cols="6">
                  <v-card flat color="#4C49ED" class="border-radius-card white--text">
                    <div class="pa-7 pb-5">

                      <div class="d-flex mb-3">
                        <div>
                          <div class="fs-12">
                            Balance
                          </div>
                          <div class="fs-20">
                            $5,756
                          </div>
                        </div>
                        <v-spacer />
                        <div>
                          <v-img
                            contain
                            alt="Mitra Warung"  
                            width="35"
                            src="@/assets/icon/chipCard.png"
                            class="mx-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class=" "
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>
                      </div>
  
  
                      <v-row>
                        <v-col cols="6">
                          <div class="fs-12">
                            CARD HOLDER
                          </div>
                          <div class="fs-15">
                            Eddy Cusuma
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="fs-12">
                            VALID THRU
                          </div>
                          <div class="fs-15">
                            12/22
                          </div>
                        </v-col>
                      </v-row>
                    </div>

                    <v-img
                      alt="Mitra Warung"
                      height="70"
                      class="align-center justify-center white--text px-7"
                      src="@/assets/background/dashboardWhite.png"
                      >
                      
                      <div class="d-flex">
                        <div class="fs-22">
                          3778 **** **** 1234
                        </div>
  
                        <v-spacer />
  
                        <div>
                          <v-img
                            contain
                            alt="Mitra Warung"  
                            width="44"
                            src="@/assets/icon/masterCardWhite.png"
                            class="mx-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class=" "
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>
                      </div>
                    </v-img>
                    
                  </v-card>
                </v-col>

                <v-col cols="6">
                  <v-card flat color="#FFFFFF" class="border-radius-card">
                    <div class="pa-7 pb-5">

                      <div class="d-flex mb-3">
                        <div>
                          <div class="fs-12">
                            Balance
                          </div>
                          <div class="fs-20">
                            $5,756
                          </div>
                        </div>
                        <v-spacer />
                        <div>
                          <v-img
                            contain
                            alt="Mitra Warung"  
                            width="35"
                            src="@/assets/icon/chipCardGrey.png"
                            class="mx-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class=" "
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>
                      </div>
  
  
                      <v-row>
                        <v-col cols="6">
                          <div class="fs-12">
                            CARD HOLDER
                          </div>
                          <div class="fs-15">
                            Eddy Cusuma
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="fs-12">
                            VALID THRU
                          </div>
                          <div class="fs-15">
                            12/22
                          </div>
                        </v-col>
                      </v-row>
                    </div>

                    <v-divider></v-divider>

                    <v-img
                      contain
                      alt="Mitra Warung"
                      height="70"
                      class="align-center justify-center px-7"
                      src="@/assets/background/dashboardWhite.png"
                      >
                      
                      <div class="d-flex">
                        <div class="fs-22">
                          3778 **** **** 1234
                        </div>
  
                        <v-spacer />
  
                        <div>
                          <v-img
                            contain
                            alt="Mitra Warung"  
                            width="44"
                            src="@/assets/icon/masterCardGrey.png"
                            class="mx-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class=" "
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>
                      </div>
                    </v-img>
                    
                  </v-card>
                </v-col>
              </v-row>

            </v-col>

            <v-col cols="12" md="4">
              <div class="fs-22 color-dark-blue font-weight-medium mb-4">
                My Expense
              </div>

              
              <v-card flat class="pa-2 border-radius-card">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 213px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 fs-17 color-light-blue">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </v-card-text>
                <div id="chart" v-if="!process.load && weekly">
                  <apexchart type="bar" height="213" :options="weekly.chartOptions" :series="weekly.series"></apexchart>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="fs-22 color-dark-blue font-weight-medium mb-4">
                Recent Transactions              
              </div>


              <v-tabs
                v-model="tabs"
                dense
                background-color="transparent"
                v-on:change="fetch()"
                slider-size="5"
                color="#1814F3">
                <v-tab
                  v-for="(item, index) in tab"
                  :key="index">
                  <span
                    class="body-2 font-weight-bold text-capitalize">
                    {{ item }}
                  </span>
                </v-tab>
              </v-tabs>
              <v-divider style="border-color: #EBEEF2;"></v-divider>



              <v-card 
                flat
                class="mt-6"
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <v-data-table
                  v-model="selected.row"
                  ref="table-grid"
                  class="table-grid"
                  :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '248px'})`"
                  :show-select="checkbox"
                  :single-select="true"
                  :loading="process.load"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  :options.sync="options"
                  :headers="configHeaders"
                  :items="list"
                  :items-per-page="100"
                  item-key="id"
                  @click:row="rowClick"
                  @toggle-select-all="handleToggleAll($event)"
                  @dblclick:row="doubleClick"
                  hide-default-footer>
                  <template
                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                    v-slot:[`item.${header.value}`]="{ value }">
                    <div
                      v-bind:key="header.value">
                      <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link' && header.format !== 'amount'">
                        {{ rowFormat(header.format, value) }} 
                      </div>

                      <div v-if="header.format === 'link'"
                        class="cursor-pointer">
                        
                      </div>
        
                      <div v-if="header.format === 'regex'">
                        <span
                          class="two-line">
                          {{ rowFormat(header.format, value) }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'image'"
                        class="ma-4">
                        <v-avatar
                          size="60"
                          tile
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="Mitra Warung" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  color="#718EBF">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>

                      <div v-if="header.format === 'image_potrait'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="100"
                          height="125"
                          alt="Mitra Warung" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                color="#718EBF">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'image_landscape'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="200"
                          height="125"
                          alt="Mitra Warung" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                color="#718EBF">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'action'">
                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              outlined
                              rounded
                              v-bind="attrs"
                              v-on="on"
                              elevation="0"
                              color="#123288"
                              height="35"
                              width="150"
                              class="text-capitalize ma-2"
                            >
                              Download
                            </v-btn>
                          </template>

                          <span>Download</span>
                        </v-tooltip>
                      </div>

                      <div v-if="header.format === 'status'"
                        class="d-flex justify-start text-capitalize font-weight-medium" :class="value == 'Publish' ? 'blue--text text--darken-2' : 'red--text'">
                        {{ value }}
                      </div>

                      <div v-if="header.format === 'amount'" :style="parseInt(value) > 0 ? 'color: #41D4A8;' : 'color: #FF4B4A;'">
                        {{ value }}
                      </div>

                      <!-- <div v-if="header.format === 'icon'" :style="parseInt(value) > 0 ? 'color: #41D4A8;' : 'color: #FF4B4A;'">
                        {{ value }}
                        <v-icon v-if="parseInt(value) < 0">mdi-arrow-up-circle-outline</v-icon>

                        <v-icon v-if="parseInt(value) > 0">mdi-arrow-down-circle-outline</v-icon>
                      </div> -->
                    </div>
                  </template>

                  <template v-slot:item.name="{ item }">
                    <v-icon class="mr-2" size="25" v-if="parseInt(item.iron) < 0">mdi-arrow-up-thin-circle-outline</v-icon>
                    
                    <v-icon class="mr-2" size="25" v-if="parseInt(item.iron) > 0">mdi-arrow-down-thin-circle-outline</v-icon>
                    {{ item.name }}
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    {{ lastIndex + index }}
                  </template>

                  <v-progress-linear 
                    v-show="process.load" 
                    slot="progress" 
                    color="white" 
                    indeterminate>
                  </v-progress-linear>
                </v-data-table>

                <pagination v-if="pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination"/>
              </v-card>

            </v-col>
          </v-row>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        tabs: 0,
        tab: ['All Transactions', 'Income', 'Expense'],
        weekly: {
          series: [
            {
            name: 'Withdraw',
            data: [76, 85, 101, 98, 87, 105]
          }],
          chartOptions: {
            chart: {
              height: '200px',
              type: 'bar',
              toolbar: {
                show: false,
              }
            },
            plotOptions: {
              bar: {
                borderRadius: 10,
                dataLabels: {
                  position: 'top', // top, center, bottom
                },
              }
            },
            colors: ['#16DBCC'],
            dataLabels: {
              enabled: true,
              formatter: function (val) {
                return val + "%";
              },
              offsetY: -20,
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              }
            },
            
            xaxis: {
              categories: ["Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
              // position: 'top',
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: false
              },
              crosshairs: {
                fill: {
                  type: 'gradient',
                  gradient: {
                    colorFrom: '#D8E3F0',
                    colorTo: '#BED1E6',
                    stops: [0, 100],
                    opacityFrom: 0.4,
                    opacityTo: 0.5,
                  }
                }
              },
              tooltip: {
                enabled: false,
              }
            },
            tooltip: {
              enabled: false,
            },
            yaxis: {
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: false,
              },
              labels: {
                show: false,
                formatter: function (val) {
                  return val + "%";
                }
              }
            
            },
            // title: {
            //   text: 'Monthly Inflation in Argentina, 2002',
            //   floating: true,
            //   offsetY: 330,
            //   align: 'center',
            //   style: {
            //     color: '#444'
            //   }
            // }
          },

          // chartOptions: {
          //   chart: {
          //     type: 'bar',
          //     height: 350,
          //     toolbar: {
          //     show: false,
          //     }
          //   },
          //   plotOptions: {
          //     bar: {
          //       horizontal: false,
          //       borderRadius: 10,
          //       columnWidth: '55%'
          //     },
          //   },
          //   colors: ['#16DBCC'],
          //   dataLabels: {
          //     enabled: false
          //   },
          //   stroke: {
          //     show: true,
          //     width: 2,
          //     colors: ['transparent']
          //   },
          //   legend: {
          //     show: false,
          //     showForSingleSeries: true,
          //     position: 'top',
          //     horizontalAlign: 'right',
          //     floating: true,
          //   },
          //   xaxis: {
          //     categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
          //   },
          //   yaxis: {
              
          //     // title: {
          //     //   text: '$ (thousands)'
          //     // }
          //   },
          //   fill: {
          //     opacity: 1
          //   },
          //   tooltip: {
          //     y: {
          //       formatter: function (val) {
          //         return "$ " + val
          //       }
          //     }
          //   }
          // },
        },

        headers: [
          {
            text: 'Description',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          { text: 'Transaction ID', value: 'calories' },
          { text: 'Type', value: 'fat' },
          { text: 'Card', value: 'carbs' },
          { text: 'Date', value: 'protein' },
          { text: 'Amount', value: 'iron' },
          { text: 'Receipt', value: ''}
        ],
        list: [
          {
            name: 'Spotify Subscription',
            calories: '#12548796',
            fat: 'Shopping',
            carbs: '1234 ****',
            protein: '28 Jan, 12.30 AM',
            iron: '-2,500',
          },
          {
            name: 'Freepik Sales',
            calories: '#12548796',
            fat: 'Transfer',
            carbs: '1234 ****',
            protein: '24 Jan, 10.30 AM',
            iron: '+750',
          },
        ],


        selected: {
          row_berita: [],
          row_kegiatan: [],
          row_sub_kegiatan: [],

          freeze: [],
          delete: []
        },

        options: {},
        headers: [],
        // list: [],
        list_sub: [],
        list_child: [],
        pagination: {},

        lastIndex: 0,
        limit: 50,

        process: {
          load: true
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },


      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },

    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    mounted () {
      setTimeout(() => {
        this.process.load = false
      }, 1000)
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        } else if (format === 'amount') {
          data = value
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      
      async fetch (pagination = { row: 50, page: 1 }) {
        this.headers = [
          {
            text: 'Description',
            width: '200px',
            value: 'name',
            freeze: true,
            hide: false,
            format: 'icon'
          },
          {
            text: 'Transaction ID',
            width: '200px',
            value: 'calories',
            freeze: false,
            hide: false
          },
          {
            text: 'Type',
            width: '150px',
            value: 'fat',
            freeze: false,
            hide: false
          },
          {
            text: 'Date',
            width: '150px',
            value: 'protein',
            freeze: false,
            hide: false
          },
          {
            text: 'Amount',
            width: '120px',
            value: 'iron',
            freeze: false,
            hide: false,
            format: 'amount'
          },
          {
            text: '',
            width: '110px',
            value: 'id',
            freeze: true,
            hide: false,
            align: 'center',
            format: 'action'
          },
        ]
        // this.process.load = true

        // this.limit = pagination.row

        // let params = {
        //   category_id: this.selected.category_id,
        //   limit: pagination.row,
        //   page: pagination.page,
        //   sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
        //   order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
        //   search: this.search,
        //   // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
        // }

        // this.selected.row = []

        // // admin/services/data

        // await get(`admin/objection/data`, { params })
        // .then(response => {
        //   let res = response.data

        //   this.process.load = false

        //   // this.list = []
        //   this.pagination = {}
            
        //   if (res.status === 200) {

        //     // this.list = res.results.data
        //     this.pagination = res.results.pagination

        //     // this.list.map(obj => {
        //     //   obj.is_active = obj.is_active === 'Aktif' ? true : false
        //     // })

        //     this.lastIndex = (pagination.page - 1) * pagination.row 
        //     this.lastIndex += 1


        //     this.addFreezes()

        //     this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

        //     if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
        //   }
        // })
      },


      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
    }
  }
</script>

<style>
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;

    /* background-color: #718EBF; */
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  }


  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
</style>